export const notify = (dispatch, message, type = 'success') => {
  dispatch({
    type: 'SHOW',
    text: message,
    toast_type: type
  });
};
